<template>
    <div class="filters-block">
        Filters:
        <span
            class="filters-block__no-filters"
            v-if="!filters.length"
        >No filters</span>
        <FilterLabel
            v-for="(filter,filterIndex) in filters"
            :key="filterIndex"
            :changes="filter.changes"
            @click="filterRemove(filterIndex)"
            @mouseover="showTooltip($event,'filtersBlockFilterTooltip',filter)"
        >
            {{ filter.name }} {{ filter.type === 'sub' ? `(${filter.type.slice(0, 1)})` : '' }}
        </FilterLabel>
        <div
            class="filters-block__delete"
            v-if="filters.length"
            @click="clearAllFilters"
        ><span class="filters-block__delete-sign">+</span><span class="filters-block__delete-text">Clear all</span>
        </div>
    </div>
</template>

<script>
    import FilterLabel from '@/pages/Dashboard/FiltersBlock/FilterLabel';
    
    export default {
        name: 'FiltersBlock',
        components: {
            FilterLabel,
        },
        props: {
            filters: {
                type: Array,
                required: true,
            },
            sync: {
                type: Boolean,
                default: true,
            },
        },
        methods: {
            filterRemove(filterRemovedIndex) {
                if (this.sync) {
                    const newFilters = this.filters.filter((filter) => filter.name !==
                        this.filters[filterRemovedIndex].name);
                    this.$emit('update:filters', newFilters);
                } else {
                    this.$emit('remove', filterRemovedIndex, this.filters[filterRemovedIndex]);
                    this.showTooltip(null, null, null);
                }
            },
            clearAllFilters() {
                this.$emit('clearAllFilters');
            },
            showTooltip(event, tooltipFunctionName, data) {
                this.$emit('showTooltip', event, tooltipFunctionName, data);
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .filters-block {
        height: 38px;
        width: 100%;
        display: flex;
        align-items: center;
        position: relative;
        flex-wrap: wrap;
        border: 1px solid $primary-color;
        background: #FFFFFF;
        border-radius: 5px;
        padding-left: 15px;
        
        
        &__no-filters {
            color: $primary-color;
            padding-left: 5px;
        }
        
        &__delete {
            position: absolute;
            right: 15px;
            cursor: pointer;
            color: $primary-color;
            padding-left: 10px;
            
            
            &-sign {
                transform: rotate(
                        45deg
                );
                position: absolute;
                left: 0px;
            }
            
            &-text {
                //border-bottom: 1px solid $primary-color;
                text-decoration: underline;
            }
        }
    }
</style>
